/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import selectedEmbedEmailData from 'state/reducers/emailCollectionState/selected_embed_email_data';
import selectedEmbedEmailStatus from 'state/reducers/emailCollectionState/selected_embed_email_status';

import { history } from '@insticator/insticator-ui'; // iui-material


/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const rootReducer = combineReducers({
    router: connectRouter(history),
    selectedEmbedEmailData,
    selectedEmbedEmailStatus
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default rootReducer;
